(function () {
  if (window.cvSgReady) return;
  window.cvSgReady = true;

  document.addEventListener('click', function (e) {
    var dialog = document.querySelector('[data-cv-sg]');
    if (!dialog) return;

    if (e.target.closest('[data-cv-sg-open]')) {
      dialog.showModal();
      return;
    }

    if (e.target.closest('[data-cv-sg-close]')) {
      dialog.close();
      return;
    }

    if (e.target === dialog) {
      dialog.close();
      return;
    }

    var unitBtn = e.target.closest('[data-cv-sg-unit]');
    if (unitBtn) {
      var unit = unitBtn.getAttribute('data-cv-sg-unit');
      dialog.querySelectorAll('[data-cv-sg-unit]').forEach(function (b) {
        b.classList.toggle('is-active', b === unitBtn);
      });
      dialog.querySelectorAll('td[data-in]').forEach(function (td) {
        td.textContent = td.getAttribute('data-' + unit);
      });
    }
  });
})();